import { render } from "./Cadastro.vue?vue&type=template&id=06da3e1c&scoped=true&ts=true"
import script from "./Cadastro.vue?vue&type=script&lang=ts"
export * from "./Cadastro.vue?vue&type=script&lang=ts"

import "./Cadastro.vue?vue&type=style&index=0&id=06da3e1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06da3e1c"]])

export default __exports__